import { getDefaultRole, getInviteRoleUrl } from "../shared/rolesConfig"

const getNonNullRole = (roles) =>
  Object.entries(roles).reduce(
    (acc, [k, v]) => (v === null ? acc : Object.assign(acc, { [k]: v })),
    {}
  )

// Only keep those roles found in the provided items that for which
// a role is recorded in the roleUpdate.
const getApplicableRoles = (items, roleUpdate) =>
  items.reduce(
    (acc, item) =>
      roleUpdate[item.meta.key]
        ? Object.assign(acc, { [item.meta.key]: roleUpdate[item.meta.key] })
        : acc,
    {}
  )

export const getRoles = (items, roleUpdate, rolePermissions) => {
  const defaultRole = getDefaultRole(rolePermissions)

  return items.reduce(
    (acc, item) => {
      // Simple validation of the inital role the "user" item has in the queued item.
      // Attempt to use that initial role, as long as that role exists in the current
      // user's role permissions. Otherwise provide default role applicable to assign target.
      acc[item.meta.key] ||= getInviteRoleUrl(rolePermissions[item.role])
        ? item.role
        : defaultRole

      return acc
    },
    { ...roleUpdate }
  )
}

// roleUpdate === pendingRole commits the queue. Any other update while a
// cohort/group is queued stays on pending. Once nothing is queued, always
// write selected roles and drop pending. Leftover pending keys must not
// capture later invites: the row and the mutation both read selected.
export const resolveNextRoleSelection = ({
  peopleSelection,
  roleSelection,
  roleUpdateOrItems,
  role
}) => {
  const { selected: selectedPeople, queued: queuedPeople } = peopleSelection
  const { selected: selectedRole, pending: pendingRole } = roleSelection

  let nextSelectedRole = { ...selectedRole }
  let nextPendingRole = { ...pendingRole }
  let roleUpdate = roleUpdateOrItems

  // Optionally pass the item and role to update just that item's role.
  if (typeof role !== "undefined") {
    const items = [].concat(roleUpdateOrItems)
    roleUpdate = items.reduce(
      (acc, item) => ({
        ...acc,
        [item.meta.key]: role
      }),
      {}
    )
  }

  const committingPending = roleUpdate === pendingRole

  if (committingPending) {
    nextSelectedRole = { ...nextSelectedRole, ...roleUpdate }
    nextPendingRole = {}
  } else if (queuedPeople.length) {
    if (roleUpdate) {
      Object.assign(nextPendingRole, roleUpdate)
    } else {
      nextPendingRole = {}
    }
  } else {
    if (roleUpdate) {
      Object.assign(nextSelectedRole, roleUpdate)
    } else {
      nextSelectedRole = {}
    }
    nextPendingRole = {}
  }

  return {
    selected: getApplicableRoles(selectedPeople, nextSelectedRole),
    pending: getNonNullRole(nextPendingRole)
  }
}
